// Predefined Skills for Political Professionals
export const PREDEFINED_SKILLS = [
  "Campaign Management",
  "Fundraising",
  "Digital Strategy",
  "Field Organizing",
  "Voter Outreach",
  "Social Media Management",
  "Data Analysis",
  "Public Speaking",
  "Grassroots Organizing",
  "Policy Analysis",
  "Communications",
  "Event Planning",
  "Volunteer Management",
  "GOTV (Get Out The Vote)",
  "Email Marketing",
  "Coalition Building",
  "Press Relations",
  "Community Organizing",
  "Political Research",
  "Opposition Research",
  "Debate Preparation",
  "Speech Writing",
  "Media Training",
  "Legislative Affairs",
  "Political Consulting",
  "Campaign Finance",
  "Voter Registration",
  "Phone Banking",
  "Canvassing",
  "Direct Mail",
  "Advertising Strategy",
  "Polling Analysis",
  "Microtargeting",
  "Voter File Management",
  "Compliance",
  "Budget Management",
  "Donor Relations",
  "Major Gifts",
  "Event Fundraising",
  "Online Fundraising",
  "Grant Writing",
  "Political Writing",
  "Content Creation",
  "Video Production",
  "Graphic Design",
  "Web Development",
  "Database Management",
  "CRM Management",
  "Analytics",
  "A/B Testing"
];

// US States
export const US_STATES = [
  "Alabama", "Alaska", "Arizona", "Arkansas", "California",
  "Colorado", "Connecticut", "Delaware", "Florida", "Georgia",
  "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa",
  "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland",
  "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri",
  "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey",
  "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio",
  "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina",
  "South Dakota", "Tennessee", "Texas", "Utah", "Vermont",
  "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming",
  "District of Columbia"
];
